<template>
  <fc-designer ref="designer" height="100vh" />
</template>

<script>
import FcDesigner from '@form-create/designer';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

export default {
  name: "FCDesigner",
  components: {FcDesigner, ElementPlus}
}
</script>

<style scoped>

</style>